import { createFileRoute } from "@tanstack/react-router";
import { BlogIndex } from "@/components/blog/BlogIndex";
import { listedPosts, SITE_URL } from "@/lib/blog";

const TITLE = "Stamp Collecting Blog | Carolina Mountain Stamps";
const DESCRIPTION =
  "Philately notes from our Hendersonville shop: starting a collection, first day covers, and how to tell if old stamps are worth anything.";
const OG_IMAGE = `${SITE_URL}/images/blog/beginners-guide.webp`;

export const Route = createFileRoute("/blog/")({
  component: BlogIndex,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE_URL}/blog` },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/blog` }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Blog",
          name: "Carolina Mountain Stamps Blog",
          description: DESCRIPTION,
          url: `${SITE_URL}/blog`,
          publisher: {
            "@type": "Organization",
            name: "Carolina Mountain Stamps",
          },
          blogPost: listedPosts().map((p) => ({
            "@type": "BlogPosting",
            headline: p.title,
            url: `${SITE_URL}/blog/${p.slug}`,
            datePublished: p.date,
            image: p.ogImage,
          })),
        }),
      },
    ],
  }),
});
